import { productApi } from "@/services/api/products.api";
import appSnackbarService from "@/services/appSnackbar.service";
import i18n from "@/services/i18n";

interface ProductRequest {
  sortBy: string;
  descending: string;
  page: number;
  rowsPerPage: number;
  searchString: string[];
}

interface ProductPost {
  data: object;
  index: number;
}

interface ProductDelete {
  id: number;
  index: number;
  newStatus?: number;
}

export const productsState: any = {
  namespaced: false,
  state: {
    products: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false,
    // archived products
    archivedProducts: [],
    archivedTotalItem: 0,
    archivedTotal: 0,
    archivedLoading: true,
    archivedFetching: false
  },
  mutations: {
    // load surveyMaterials
    ITEMS_FETCH_SUCCESS(state: any, payload: any) {
      state.products = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
    },
    ITEMS_FETCH_START(state: any) {
      state.fetching = true;
    },
    ITEMS_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // save
    ITEM_SAVE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        // letörli a (payload.index)-ű elemet
        state.products.splice(payload.index, 1, payload.data);
        // és betölti a data elemet
        // state.supplyAreas[payload.index] = payload.data;
      } else {
        // add
        state.products.push(payload.data);
      }
    },
    ITEM_SAVE_START(state: any) {
      state.fetching = true;
    },
    ITEM_SAVE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // delete
    ITEM_DELETE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        state.products.splice(payload.index, 1);
        state.loading = false;
      }
    },
    ITEM_DELETE_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    ITEM_DELETE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },

    // Archived products mutations
    ARCHIVED_ITEMS_FETCH_SUCCESS(state: any, payload: any) {
      state.archivedProducts = payload.data;
      state.archivedTotal = payload.data.length;
      state.archivedTotalItem = payload.totalCount;
      state.archivedLoading = false;
      state.archivedFetching = false;
    },
    ARCHIVED_ITEMS_FETCH_START(state: any) {
      state.archivedFetching = true;
    },
    ARCHIVED_ITEMS_FETCH_ERROR(state: any, payload: any) {
      state.archivedFetching = false;
      state.error = payload;
    },

    // restore
    ITEM_RESTORE_SUCCESS(state: any, payload: any) {
      // Remove the restored item from archived products
      const index = state.archivedProducts.findIndex(item => item.productId === payload.productId);
      if (index > -1) {
        state.archivedProducts.splice(index, 1);
        state.archivedTotalItem = state.archivedTotalItem - 1;
      }
    },
    ITEM_RESTORE_START(state: any) {
      state.archivedFetching = true;
    },
    ITEM_RESTORE_ERROR(state: any, payload: any) {
      state.archivedFetching = false;
      state.error = payload;
    },
    ITEM_UPDATE_DELETE_STATUS_START(state: any) {
      // Could add loading state if needed
    },
    ITEM_UPDATE_DELETE_STATUS_SUCCESS(state: any, payload: any) {
      // Update the delete status text in the archived products list
      const product = state.archivedProducts.find((item: any) => item.productId === payload.productId);
      if (product) {
        const newStatusText = payload.newStatus === 0 ? "" :
                             payload.newStatus === 1 ? "Értékesítés" :
                             payload.newStatus === 2 ? "Selejt" :
                             payload.newStatus === 3 ? "Adomány" : "";
        product.deleteStatusText = newStatusText;
      }
    },
    ITEM_UPDATE_DELETE_STATUS_ERROR(state: any, error: any) {
      console.error("Update delete status error:", error);
    },
  },
  actions: {
    getProducts({ commit }: any, request: ProductRequest) {
      commit("ITEMS_FETCH_START");
      productApi
        .getAll(request)
        .then(response => {
          commit("ITEMS_FETCH_SUCCESS", response.data);
        })
        .catch(error => {
          commit("ITEMS_FETCH_ERROR", error);
        });
    },
    getArchivedProducts({ commit }: any, request: ProductRequest) {
      commit("ARCHIVED_ITEMS_FETCH_START");
      productApi
        .getArchived(request)
        .then(response => {
          commit("ARCHIVED_ITEMS_FETCH_SUCCESS", response.data);
        })
        .catch(error => {
          commit("ARCHIVED_ITEMS_FETCH_ERROR", error);
        });
    },
    restoreProduct({ commit }: any, productId: number) {
      commit("ITEM_RESTORE_START");
      productApi
        .restore(productId)
        .then(response => {
          commit("ITEM_RESTORE_SUCCESS", { productId });
          appSnackbarService.success(i18n.t("SUCCESS_MESSAGES.PRODUCT_RESTORED"));
        })
        .catch(error => {
          commit("ITEM_RESTORE_ERROR", error);
          appSnackbarService.error("Hiba történt a termék visszaállítása során");
        });
    },
    updateDeleteStatus({ commit }: any, payload: { productId: number, newStatus: number }) {
      commit("ITEM_UPDATE_DELETE_STATUS_START");
      productApi
        .updateDeleteStatus(payload.productId, payload.newStatus)
        .then(response => {
          commit("ITEM_UPDATE_DELETE_STATUS_SUCCESS", { productId: payload.productId, newStatus: payload.newStatus });
          appSnackbarService.success("Törlés oka sikeresen frissítve");
        })
        .catch(error => {
          commit("ITEM_UPDATE_DELETE_STATUS_ERROR", error);
          appSnackbarService.error("Hiba történt a törlés oka frissítése során");
        });
    },
    saveProduct({ commit }: any, payload: ProductPost) {
      commit("ITEM_SAVE_START");
      const editedIndex = payload.index;
      const promise = new Promise((resolve, reject) => {

        productApi
          .save(payload.data)
          .then(response => {
            commit("ITEM_SAVE_SUCCESS", {
              data: response.data,
              index: editedIndex
            });
            appSnackbarService.success(i18n.t("SUCCESS_MESSAGES.PRODUCT_SAVED"));
            resolve(response);
          })
          .catch(error => {
            commit("ITEM_SAVE_ERROR", error);
            // appSnackbarService.error(error);
            reject(error);
          });
        });
      return promise;
    },
    deleteProduct({ commit }: any, payload: ProductDelete) {
      commit("ITEM_DELETE_START");
      console.log(payload);

      const deletedIndex = payload.index;
      productApi
        .delete(payload.id, payload.newStatus)
        .then(response => {
          commit("ITEM_DELETE_SUCCESS", {
            data: response.data,
            index: deletedIndex
          });
          appSnackbarService.warning(i18n.t("SUCCESS_MESSAGES.PRODUCT_DELETED"));
        })
        .catch(error => {
          commit("ITEM_DELETE_ERROR", error);
          // appSnackbarService.error(error);
        });
    },
  }
};
